import { Flex, Image, Spinner } from '@chakra-ui/react';
import { apiSalesWeb } from '@shared/config';
import { apiNexpro } from '@shared/config/apiNexpro';
import { links } from '@shared/utils';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { getSessionAuth } from '../services';
import { createRequestId } from '../services/createRequestId';

export const CrossSellerLayout = () => {
  const [haveRequestId, setHaveRequestId] = useState(false);

  const getRequestId = async () => {
    const requestIdSession = sessionStorage.getItem('requestId');
    if (!requestIdSession) {
      const { data } = await createRequestId();

      sessionStorage.setItem('requestId', data.requestId);

      apiSalesWeb.defaults.headers['request-id'] = data.requestId;
      setHaveRequestId(true);

      return;
    }

    setHaveRequestId(true);
    apiSalesWeb.defaults.headers['request-id'] = requestIdSession;
    return;
  };

  const getAuthentication = async () => {
    const haveAuthentication = sessionStorage.getItem('accessToken');
    if (haveAuthentication) {
      apiNexpro.defaults.headers.Authorization = `Bearer ${haveAuthentication}`;
      apiSalesWeb.defaults.headers.Authorization = `Bearer ${haveAuthentication}`;
      return;
    }

    const authId = sessionStorage.getItem('authId');
    const regexId = /id=([^&]+)/;
    const regexCompanyId = /companyId=([^&]+)/;
    const id = window.location.search.match(regexId)?.[1] || '';
    const companyId = window.location.search.match(regexCompanyId)?.[1] || '';

    if (!haveAuthentication && !id) {
      window.history.replaceState({}, document.title, links.checkout.main);
    }

    if (window.location.search.includes('id') && authId !== id) {
      try {
        sessionStorage.setItem('authId', id);
        sessionStorage.setItem('companyId', companyId);
        const { data } = await getSessionAuth(id);
        sessionStorage.setItem('accessToken', data.externalToken);
        apiNexpro.defaults.headers.Authorization = `Bearer ${data.externalToken}`;
        apiSalesWeb.defaults.headers.Authorization = `Bearer ${data.externalToken}`;
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      } catch (error) {
        console.log(error);
      } finally {
        sessionStorage.removeItem('firstSend');
      }
    }
  };

  useEffect(() => {
    getRequestId();
    getAuthentication();
  }, []);

  return (
    <Flex maxH="100dvh" overflow="auto">
      <Flex
        width={100}
        bgImage="/images/sidebar.png"
        justifyContent="center"
        alignItems="start"
        p={4}
        display={{ base: 'none', lg: 'flex' }}
      >
        <Image src="/images/Icon.png" alt="logo" />
      </Flex>
      {haveRequestId ? (
        <Outlet />
      ) : (
        <Flex justifyContent="center" alignItems="center" w="full" h="100dvh">
          <Spinner size="xl" />
        </Flex>
      )}
    </Flex>
  );
};
